<script lang="ts" setup>
// Feuille de sélection du dossier actif (port de MobileDossierSheet).
import type { MobileDossier } from './mobileMockData';

defineProps<{ dossiers: MobileDossier[]; active: string }>();
const emit = defineEmits<{ select: [id: string]; close: [] }>();

function choose (id: string): void {
  emit('select', id);
  emit('close');
}
</script>

<template>
  <MobileSheet
    title="Dossiers ouverts"
    @close="emit('close')"
  >
    <button
      v-for="d in dossiers"
      :key="d.id"
      :class="['gm-dossier-opt', { on: d.id === active }]"
      @click="choose(d.id)"
    >
      <span :class="['gm-do-act', d.activity === 'RAC' ? 'rac' : 'ade']">{{ d.activity }}</span>
      <span class="gm-do-name">{{ d.client }}</span>
      <span class="gm-do-id">#{{ d.id }}</span>
      <DsIcon
        v-if="d.id === active"
        name="check"
        :size="15"
      />
    </button>
  </MobileSheet>
</template>
